import { TenantConfig } from '@/types/TenantConfig'

const orange = '#f99d22'
const brown = '#504841'
const white = '#fff'
const grey = '#3e3e50'

export const aucklandzoo: TenantConfig = {
  logo: 'assets/aucklandzoo/static/logo.svg',

  themeOptions: {
    primaryColor: orange,
    logoHeight: '40px',
    headerHeight: '60px',
    headerBottomBorder: '1px solid #ccc',
    footerTextColor: white,
    footerBackgroundColor: brown,
    cartHeaderBackgroundColor: grey,
  },
}
